import PropTypes from 'prop-types';

const Cluster = ({ points, pointCount, onClick }) => {
	return (
		<div
			className="cluster-marker"
			style={{
				width: `${30 + (pointCount / points.length) * 20}px`,
				height: `${30 + (pointCount / points.length) * 20}px`,
			}}
			onClick={onClick}
		>
			{pointCount}
		</div>
	);
};

Cluster.propTypes = {
	points: PropTypes.arrayOf(PropTypes.object),
	pointCount: PropTypes.number,
	onClick: PropTypes.func,
};

export default Cluster;
